window.addToCart = async function(event, button) {
  event.preventDefault();
  
  const productId = button.dataset.productId;
  if (!productId) return;

  // 禁用按钮防止重复点击
  button.disabled = true;
  
  try {
    // 发送加购请求
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');
    
    // 获取最新购物车数据
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    // 尝试不同的事件来触发购物车更新
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // 触发购物车抽屉打开事件
    const cartDrawerToggle = document.querySelector('.t4s-site-nav__cart a.tdf_cart_icon');
    if (cartDrawerToggle) {
      cartDrawerToggle.click();
    }

  } catch (error) {
    console.error('Error adding to cart:', error);
  } finally {
    button.disabled = false;
  }
};
